/**
 * number of (non iframe) page views per session before login/registration auto prompt
 */
export const VISITS_PER_SESSION_LOGIN_PROMPT = 2;
export const VISITS_PER_SESSION_LOGIN_PROMPT_SB_LANDING = 1;

/**
 * length of time before local storage values "expire" as session values
 * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
 */
export const PSEUDO_SESSION_EXPIRES_AT = 14400000;

export const KEY_STORAGE = 'visitCount';
export const KEY_PSEUDO_SESSION_STORAGE = 'pseudoSessionVisitCount';
export const KEY_PRE_REGISTRATION_PAGE_VISIT = '_dibsPreRegistrationPageVisit';
export const TYPE_PRE_REGISTRATION_PAGE_VISIT = 'PRE_REGISTRATION_PAGE_VISIT';
export const CAP_PRE_REGISTRATION_PAGE_VISIT = 100;
export const KEY_SESSION_INITIATED = 'sessionInitiated';
export const KEY_SESSION_STORAGE = 'sessionVisitCount';
